<textarea #richEditorDiv style="visibility: hidden"></textarea>

@if (!editorIsReady()) {
  <div class="loading-screen">
    <mat-spinner diameter="32" />
  </div>
}
